import type { FunctionComponent, Dispatch, SetStateAction } from 'react';
import React from 'react';

import type {
  CustomValidityMessages,
  UpdateFieldType,
} from '../contactForm/ContactForm';
import style from '../contactForm/ContactForm.module.scss';
import RequestCancelForm from './RequestCancelForm';
import RequestClaimForm from './RequestClaimForm';
import RequestCommercialNetworkForm from './RequestCommercialNetworkForm';
import RequestCommercialPartnerForm from './RequestCommercialPartnerForm';
import RequestInformationForm from './RequestInformationForm';

import type { ContactFormData } from 'src/models/contact';

import { mergeClassNames } from 'src/utils/ReactUtils';

type RequestContactFormType = {
  updateField: UpdateFieldType;
  formValue: ContactFormData;
  setFormValue: Dispatch<SetStateAction<ContactFormData>>;
  customValidityMessages: CustomValidityMessages;
};

const RequestContactForm: FunctionComponent<RequestContactFormType> = ({
  updateField,
  formValue,
  setFormValue,
  customValidityMessages,
}) => {
  if (
    !formValue.requestType ||
    (formValue.requestType === 1 &&
      (!formValue.subRequestType || formValue.subRequestType === 3)) ||
    (formValue.requestType === 2 &&
      (!formValue.rendezVous || formValue.rendezVous === 2)) ||
    (formValue.requestType === 3 &&
      typeof formValue.rendezVous === undefined) ||
    (formValue.requestType === 4 && !formValue.object)
  ) {
    return <></>;
  }
  return (
    <section className={style.contactForm}>
      <h2 className={style.contactSecondTitle}>VOTRE DEMANDE...</h2>
      <div className={mergeClassNames([style.contactFormContent])}>
        {[1, 5, 6].includes(formValue.requestType) && (
          <RequestInformationForm
            updateField={updateField}
            formValue={formValue}
            customValidityMessages={customValidityMessages}
          />
        )}
        {formValue.requestType === 2 && (
          <RequestCancelForm
            updateField={updateField}
            formValue={formValue}
            customValidityMessages={customValidityMessages}
          />
        )}
        {formValue.requestType === 3 && (
          <RequestClaimForm
            updateField={updateField}
            formValue={formValue}
            customValidityMessages={customValidityMessages}
          />
        )}
        {formValue.requestType === 4 && (
          <>
            {formValue.object === 1 && (
              <RequestCommercialNetworkForm
                updateField={updateField}
                formValue={formValue}
                setFormValue={setFormValue}
              />
            )}
            {formValue.object === 2 && (
              <RequestCommercialPartnerForm
                updateField={updateField}
                formValue={formValue}
              />
            )}
            {[3, 4].includes(formValue.object) && (
              <RequestInformationForm
                updateField={updateField}
                formValue={formValue}
                customValidityMessages={customValidityMessages}
              />
            )}
          </>
        )}
      </div>
      <div className={style.contactFormIndicator}>
        * Ces champs sont obligatoires pour valider votre prise de contact
      </div>
    </section>
  );
};

export default RequestContactForm;
